import React, { useState, useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom';
import { useUser } from '@supabase/auth-helpers-react';
import Sidebar from './Sidebar';
import HelpDialog from './HelpDialog';

const AuthenticatedLayout = () => {
  const user = useUser();
  const location = useLocation();
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    console.log('AuthenticatedLayout rendered:', { pathname: location.pathname });
  }, [location.pathname]);

  // Don't show sidebar on public consent page
  if (location.pathname === '/public-consent') {
    return <Outlet />;
  }

  return (
    <Flex h="100vh">
      <Sidebar setShowHelp={setShowHelp} />
      <Box
        as="main"
        flex="1"
        ml="320px" // Match the sidebar width
        p={4}
        overflowY="auto"
        bg="gray.50" // Add background color to make the main content area visible
      >
        <Outlet />
      </Box>
      <HelpDialog isOpen={showHelp} onClose={() => setShowHelp(false)} />
    </Flex>
  );
};

export default AuthenticatedLayout;
